import { useRef } from "react"

import { Divider, Flex, Spin, Typography } from "antd"
import classname from "classname"

import useHasScroll from "../../hooks/useHasScroll"
import useInteractionObserver from "../../hooks/useInteractionObscerver"
import DescriptorListItem from "../DescriptorListItem/DescriptorListItem"
import DescriptorsEmpty from "./DescriptorsEmpty"

import "./DescriptorsList.less"

const { Text } = Typography

const DescriptorsList = ({ descriptors, enrollment, loading, isFiltered, onLoadMore, hasMore }) => {
  const listRef = useRef(null)
  const sentinelRef = useRef(null)

  useInteractionObserver(sentinelRef, listRef, (isIntersecting) => {
    if (isIntersecting && hasMore) {
      onLoadMore()
    }
  })

  const hasScroll = useHasScroll(listRef)

  return (
    <div
      className={classname("enrollment-descriptors-list", {
        "has-scroll": hasScroll
      })}
      ref={listRef}
    >
      {descriptors?.length === 0 && !loading && (
        <DescriptorsEmpty service={enrollment?.name?.toLowerCase()} isFiltered={isFiltered} />
      )}
      {loading && (
        <Flex justify="center" align="center" style={{ height: "200px" }}>
          <Spin size="large" />
        </Flex>
      )}
      {!loading &&
        descriptors?.map((descriptor) => (
          <>
            <DescriptorListItem
              key={descriptor.id}
              descriptor={descriptor}
              service={enrollment?.name?.toLowerCase()}
            />
            <Divider />
          </>
        ))}
      {!loading && descriptors?.length > 0 && hasMore && <div ref={sentinelRef}></div>}
      {hasMore && !loading && (
        <Flex justify="center" align="center" style={{ padding: "12px 0" }}>
          <Spin size="large" />
        </Flex>
      )}
    </div>
  )
}

export default DescriptorsList
